import { postJson, send } from 'helpers/http';

if (!location.origin) {
    location.origin = location.protocol + '//' + location.host;
}

const BASE_URL = location.origin + '/';
const TIMEOUT = 100000;

export const get = (url, params = {}) => {
    return send('GET', url, { query: params, noCache: true, timeout: TIMEOUT });
};

export const post = (url, payload) => {
    return send('POST', url, { form: payload });
};

export const jsonPost = (url, params) => postJson(url, params);

export const makeUrl = (controller, part) => {
    return BASE_URL + controller + '/' + part;
};
